import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PageBreadcrumbComponent } from '@shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { UserInfoCardComponent } from '@shared/components/user-profile/user-info-card/user-info-card.component';
import {
  UserAccountCardComponent
} from '@shared/components/user-profile/user-account-card/user-account-card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-profile',
  imports: [
    PageBreadcrumbComponent,
    UserInfoCardComponent,
    UserAccountCardComponent,
    TranslatePipe
  ],
  templateUrl: './profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``
})
export class ProfileComponent {
}
